// MainLayout.jsx
import React, { useRef, useEffect } from 'react'; 
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './MainLayout.css'; 

const MainLayout = ({ children }) => {
  const mainContentRef = useRef(null);

  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.focus();
    }
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className='main-layout'>
      <div className='bg-black text-white [&_p]:text-gray-100'>
        <Navbar />
      </div>
      <div ref={mainContentRef} tabIndex="-1" className='bg-black text-white [&_p]:text-gray-100'>
        {children}
      </div>
      <div className='bg-black text-white [&_p]:text-gray-100'>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;

